import { wait } from '../common'

const form = document.querySelector('.vp-block-form-login')
const ajaxWait = 200
let errorMessage = ''
let dom = {}

if (form) {
    dom = {
        fields: form.querySelector('.fields'),
        fieldItems: form.querySelectorAll('vp-field'),
        process: form.querySelector('.process'),
        message: form.querySelector('.message'),
        sent: form.querySelector('.sent'),

        log: form.querySelector('vp-field[name="log"] input'),
        pwd: form.querySelector('vp-field[name="pwd"] input'),
    }

    dom.process.addEventListener('click', send)

    // init inputs
    dom.log.value = ''
    dom.pwd.value = ''
}

async function send() {
    const formData = {
        nonce: form.dataset.nonce,
        action: form.dataset.action,
        log: dom.log.value,
        pwd: dom.pwd.value,
    }

    // start loading
    dom.process.innerHTML = dom.process.dataset.loading
    dom.process.disabled = true
    dom.message.innerHTML = ''
    await wait(ajaxWait)

    // send
    let response
    try {
        response = await fetch(form.dataset.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: new URLSearchParams(formData),
        })
    } catch (error) {
        dom.message.innerHTML = 'Network error'
        dom.process.innerHTML = dom.process.dataset.label
        dom.process.disabled = false
        return
    }

    // end loading
    dom.process.innerHTML = dom.process.dataset.label
    dom.process.disabled = false

    // http error
    if (!response.ok) {
        dom.message.innerHTML = `Error ${response.status}`
        return
    }

    // json response
    const json = await response.json()
    if (!json.success) {
        if (typeof json.data === 'string') {
            dom.message.innerHTML = json.data
        } else {
            const dataKeys = Object.keys(json.data)
            for (const field of dom.fieldItems) {
                const name = field.getAttribute('name') || ''
                if (dataKeys.includes(name)) {
                    errorMessage = json.data[name] === '1' ? true : json.data[name]
                    field.setError(errorMessage)
                } else {
                    field.removeError()
                }
            }
        }
    } else {
        document.location.reload()
    }
}
